import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import FAQSchema from '../../FAQSchema';

const SingleDematPage = () => {
  const { id } = useParams();
  const [demat, setDemat] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const fetchDemat = async () => {
      try {
        const response = await fetch(`https://test.thefinmaster.com/console/react-app-directory/demat-api.php?id=${id}`);
        
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();
        const foundDemat = data.demat.find(demat => demat.page_url === id);
        
        setDemat(foundDemat);
      } catch (error) {
        console.error('Error fetching data:', error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchDemat();
    
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, [id]);

  const toggleAccordion = (index) => {
      setActiveIndex(index);
};
  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-gray-50">
        <div className="text-center">
          <div className="inline-block w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mb-4"></div>
          <p className="text-gray-700 font-medium">Loading...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mx-auto px-4 py-16 text-center">
        <div className="bg-red-50 p-6 rounded-lg shadow-sm">
          <h2 className="text-2xl font-bold text-red-600 mb-2">Error</h2>
          <p className="text-red-700">{error}</p>
          <Link to="/demat" className="inline-block mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors">
            Return to Demat Page
          </Link>
        </div>
      </div>
    );
  }

  if (!demat) {
    return (
      <div className="container mx-auto px-4 py-16 text-center">
        <div className="bg-yellow-50 p-6 rounded-lg shadow-sm">
          <h2 className="text-2xl font-bold text-yellow-600 mb-2">Card Not Found</h2>
          <p className="text-yellow-700">The requested card could not be found.</p>
          <Link to="/demat" className="inline-block mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors">
            Browse All Cards
          </Link>
        </div>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>{demat.metatitle}</title>
        <meta name='description' content={demat.metadesc} />
        <meta name='keywords' content={demat.metakeyword} />
      </Helmet>
      
      <FAQSchema faqs={demat.demat_faq} />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-14">
        {/* Breadcrumb */}
        <nav className="py-4 mb-4" aria-label="Breadcrumb">
          <ol className="flex items-center space-x-1 text-sm md:text-base">
            <li className="flex items-center">
              <Link to="/" className="text-blue-600 hover:text-blue-800 hover:underline">
                Home
              </Link>
              <svg className="w-4 h-4 mx-2 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
              </svg>
            </li>
            <li>
              <Link to="/demat" className="text-blue-600 hover:text-blue-800 hover:underline">
                Demat Page
              </Link>
              <svg className="w-4 h-4 mx-2 text-gray-400 inline" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
              </svg>
            </li>
            <li className="text-gray-600 truncate max-w-xs">
              {demat.page_title}
            </li>
          </ol>
        </nav>

        {/* Main content */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden mb-8">
     
          <div className="p-6">
            {/* Image and title section */}
            <div className="flex flex-col lg:flex-row gap-8">
              <div className="lg:w-1/3">
                <div className="relative pb-3/4 bg-gray-100 rounded-lg overflow-hidden shadow-sm">
                  <img
                    src={demat.image}
                    alt={demat.page_title}
                    className="w-full h-auto object-cover rounded-lg transition-transform hover:scale-105"
                    loading="eager"
                  />
                </div>
                
              </div>
              
              <div className="lg:w-2/3">
              
                <h1 className="text-2xl sm:text-3xl font-bold  text-blue-600 mb-2">
                  {demat.page_title}
                </h1>
  {/* Top-right button */}
  


                <div className="text-lg text-gray-700 ">
                  {demat.page_description}
                </div>
                <div className='py-4'>
                <a 
      href={demat.bank_link}
      target="_blank" 
      rel="noopener noreferrer"
    >
      <button className="text-xl bg-green-500 text-white font-semibold py-5 px-7 rounded-lg hover:bg-green-600 transition duration-300 w-full sm:w-auto">
        Apply Now
      </button>
    </a>
    </div>
                {/* Key features cards */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                  <div className="bg-blue-50 p-4 rounded-lg shadow-sm border border-blue-100">
                    <h3 className="text-lg font-semibold mb-2 text-blue-700">Account Opening Charges</h3>
                    <p className="text-gray-700">{demat.account_opening_chrg}</p>
                  </div>
                  
                  <div className="bg-blue-50 p-4 rounded-lg shadow-sm border border-blue-100">
                    <h3 className="text-lg font-semibold mb-2 text-blue-700">Annual Maintenance Charges</h3>
                    <p className="text-gray-700">{demat.annual_mainten_chrg}</p>
                  </div>
                  
                  <div className="bg-blue-50 p-4 rounded-lg shadow-sm border border-blue-100">
                    <h3 className="text-lg font-semibold mb-2 text-blue-700">Brokerage</h3>
                    <p className="text-gray-700">{demat.brokerage}</p>
                  </div>
                  
                </div>
              </div>
            </div>
            
            {/* Detailed information section */}
            <div className="mt-8">
              {/* <h2 className="text-2xl font-semibold mb-4 text-gray-800 border-b pb-2">Detailed Information</h2> */}
              <div className="prose max-w-none prose-blue prose-lg">
                {demat.page_details ? (
                  <div 
                    dangerouslySetInnerHTML={{ __html: demat.page_details }} 
                    className="overflow-x-auto" 
                  />
                ) : (
                  <p className="text-gray-500 italic">No additional details available.</p>
                )}
              </div>
            </div>
             <div className='py-4'>
                <a 
      href={demat.bank_link}
      target="_blank" 
      rel="noopener noreferrer"
    >
      <button className="text-xl bg-green-500 text-white font-semibold py-5 px-7 rounded-lg hover:bg-green-600 transition duration-300 w-full sm:w-auto">
        Apply Now
      </button>
    </a>
    </div>
          </div>
        </div>

        {/* FAQ section */}
      
      </div>
      {/* <div className="bg-white rounded-lg shadow-md overflow-hidden mb-12 p-6">
          <h2 className="text-3xl font-semibold text-center mb-6 text-blue-600">
            Frequently Asked Questions
          </h2>
          
          {demat.demat_faq && demat.demat_faq.length > 0 ? (
            <div className="space-y-4 ">
              {demat.demat_faq.map((faq, index) => (
                <div key={index} className="border border-gray-200 rounded-lg overflow-hidden ">
                  <button
                    onClick={() => toggleAccordion(index)}
                    className="w-full p-4 text-left text-lg font-medium focus:outline-none flex justify-between items-center hover:bg-gray-50"
                    aria-expanded={activeIndex === index}
                  >
                    <span className="pr-6">{faq.question}</span>
                    <svg
                      className={`w-5 h-5 transition-transform duration-300 ${
                        activeIndex === index ? 'rotate-180' : ''
                      }`}
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </button>
                  
                  <div 
                    className={`bg-gray-50 overflow-hidden transition-all duration-300 ${
                      activeIndex === index ? 'max-h-96' : 'max-h-0'
                    }`}
                  >
                    {activeIndex === index && (
                      <div className="p-4 text-gray-700">
                        {faq.answer}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-center text-gray-500 py-4">No FAQs are available for this card.</p>
          )}
        </div> */}
        <div className=" overflow-hidden mb-12 p-6 max-w-4xl mx-auto">
  <h2 className="text-2xl md:text-3xl font-semibold text-center mb-8">
    Frequently Asked Questions
  </h2>

  {demat.demat_faq && demat.demat_faq.length > 0 ? (
    <div className="space-y-4">
      {demat.demat_faq.map((faq, index) => (
        <div key={index} className="border border-gray-200 rounded-lg overflow-hidden">
          <button
            onClick={() => toggleAccordion(index)}
            className="w-full p-4 text-left text-lg font-medium focus:outline-none flex justify-between items-center hover:bg-gray-50"
            aria-expanded={activeIndex === index}
          >
            <span className="pr-4">{faq.question}</span>
            <svg
              className={`w-5 h-5 transform transition-transform duration-300 ${
                activeIndex === index ? 'rotate-180' : ''
              }`}
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </button>

          <div
            className={`transition-all duration-300 ease-in-out ${
              activeIndex === index ? 'max-h-[1000px]' : 'max-h-0'
            } overflow-hidden bg-gray-50`}
          >
            <div className={`p-4 text-gray-700 ${activeIndex === index ? 'block' : 'hidden'}`}>
              {faq.answer}
            </div>
          </div>
        </div>
      ))}
    </div>
  ) : (
    <p className="text-center text-gray-500 py-4">
      No FAQs are available for this card.
    </p>
  )}
</div>

    </>
  );
};

export default SingleDematPage;



// import React, { useEffect, useState } from 'react';
// import { Link, useParams } from 'react-router-dom';
// import { Helmet } from 'react-helmet';
// import FAQSchema from '../../FAQSchema';

// const SingleDematPage = () => {
//   const { id } = useParams();
//   const [demat, setDemat] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [activeIndex, setActiveIndex] = useState(0);

//   useEffect(() => {
//     const fetchDemat = async () => {
//       try {
//         const response = await fetch(`https://test.thefinmaster.com/console/react-app-directory/demat-api.php?id=${id}`);
        
//         if (!response.ok) {
//           throw new Error("Network response was not ok");
//         }

//         const data = await response.json();
//         const foundDemat = data.demat.find(demat => demat.page_url === id);
        
//         setDemat(foundDemat);
//       } catch (error) {
//         console.error('Error fetching data:', error);
//         setError(error.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchDemat();
//   }, [id]);

//   const toggleAccordion = (index) => {
//     setActiveIndex(activeIndex === index ? null : index);
//   };

//   if (loading) {
//     return (
//       <div className="spinnerContainer">
//         <div className="spinner"></div>
//         <div className="loader">
//           <p>Loading...</p>
//           <div className="words">
//             <span className="word">Images</span>
//             <span className="word">Title</span>
//             <span className="word">Card</span>
//             <span className="word">Bank Card</span>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return <p>Error: {error}</p>;
//   }

//   if (!demat) {
//     return <p>No Card found.</p>;
//   }

//   return (
//     <>
//       <Helmet>
//         <title>{demat.metatitle}</title>
//         <meta name='description' content={demat.metadesc} />
//         <meta name='keywords' content={demat.metakeyword} />
//         {/* <meta name="robots" content="noindex, nofollow" /> */}
//       </Helmet>
//       <FAQSchema faqs={demat.demat_faq} />
//       <nav className="text-gray-500 text-sm my-4 ml-12" aria-label="Breadcrumb">
//         <ol className="list-none p-0 inline-flex">
//           <li className="flex items-center">
//             <Link to="/" className="text-blue-600 hover:text-blue-800">Home</Link>
//             <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
//               <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
//             </svg>
//           </li>
//           <li className="flex items-center">
//             <Link to="/demat_page" className="text-blue-600 hover:text-blue-800">Demat Page</Link>
//           </li>
//         </ol>
//       </nav>
//       <div className="container mx-auto px-4 py-8">
//         <div className="flex flex-col lg:flex-row gap-12">
//           <div className="lg:w-3/4">
//             <div className="w-full mx-auto">
//               <img
//                 src={demat.image}
//                 alt={demat.page_title}
//                 className="w-full h-auto rounded"
//               />
//             </div>
//             <h2 className="text-3xl mt-8 font-bold mb-4 text-blue-500 cursor-pointer">
//               {demat.page_title}
//             </h2>
//             <p className="text-2xl mt-4 font-semibold mb-4 text-gray-700">
//               {demat.page_description}
//             </p>
//           </div>
//         </div>
//       </div>
//       <div className="flex-1 flex flex-col md:flex-row">
//                 {/* Account Opening Charges */}
//                 <div className="w-full md:w-1/3 p-4 border-b md:border-b-0 md:border-r border-gray-200">
//                   <h2 className="text-lg font-bold mb-2">Account Opening Charges</h2>
//                   <p className="text-gray-700">{demat.account_opening_chrg}</p>
//                 </div>
                
//                 {/* Annual Maintenance Charges */}
//                 <div className="w-full md:w-1/3 p-4 border-b md:border-b-0 md:border-r border-gray-200">
//                   <h2 className="text-lg font-bold mb-2">Annual Maintenance Charges</h2>
//                   <p className="text-gray-700">{demat.annual_mainten_chrg}</p>
//                 </div>
                
//                 {/* Brokerage */}
//                 <div className="w-full md:w-1/3 p-4">
//                   <h2 className="text-lg font-bold mb-2">Brokerage</h2>
//                   <p className="text-gray-700">{demat.brokerage}</p>
//                 </div>
//               </div>
            
//       <div className="text-gray-700 text-base mb-6 px-4 sm:px-6 md:px-8 lg:px-12">
//   {demat.page_details ? (
//     <div dangerouslySetInnerHTML={{ __html: demat.page_details }}  className="scrollable-table" />
//   ) : (
//     <p>No additional details available.</p>
//   )}
// </div>
//       <div className="max-w-4xl mx-auto py-6">
//         <h1 className="text-3xl font-semibold text-center mb-8">Frequently Asked Questions</h1>
//         {demat.demat_faq.length > 0 ? (
//           <div className="space-y-4">
//             {demat.demat_faq.map((faq, index) => (
//               <div key={index} className="border rounded-lg overflow-hidden shadow-md">
//                 <button
//                   onClick={() => toggleAccordion(index)}
//                   className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
//                 >
//                   {faq.question}
//                   <svg
//                     className={`w-6 h-6 transition-transform transform ${
//                       activeIndex === index ? 'rotate-180' : ''
//                     }`}
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth="2"
//                       d={activeIndex === index ? 'M19 9l-7 7-7-7' : 'M9 5l7 7 7-7'}
//                     />
//                   </svg>
//                 </button>
//                 {activeIndex === index && (
//                   <div className="p-4 bg-gray-100">
//                     <p className="text-gray-600">{faq.answer}</p>
//                   </div>
//                 )}
//               </div>
//             ))}
//           </div>
//         ) : (
//           <p className="text-center text-gray-500">No FAQs available.</p>
//         )}
//       </div>
//     </>
//   );
// };

// export default SingleDematPage;




// import React, { useEffect, useState } from 'react';
// import { Link, useParams } from 'react-router-dom';
// // import SideBar from './SideBar';
// import { Helmet } from 'react-helmet';
// import FAQSchema from '../../FAQSchema';

// const SingleDematPage = () => {
//   const { id } = useParams();
// //   console.log('ID from useParams:', id);
//   const [demat, setDemat] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//     const [activeIndex, setActiveIndex] = useState(0);
//   useEffect(() => {
//     const fetchDemat = async () => {
//       try {
//         //  console.log(`Fetching card with ID: ${id}`);
//         const response = await fetch(`https://test.thefinmaster.com/console/react-app-directory/demat-api.php?id=${id}`);
        
//         if (!response.ok) {
//           throw new Error("Network response was not ok");
//         }
        
//         const data = await response.json();
        
//         // Log data to understand the structure
//         // console.log("Fetched Data:", data);

//         // Extract the blogs array
//         // const blogs = data.blogs;
        
//         // Find the specific blog by ID
//         // const foundBlog = blogs.find(blog => blog.url === id);
//         const foundDemat = data.demat.find(demat => demat.page_url === id);

//         // console.log("Found loan:", foundLoan);
        
//         setDemat(foundDemat);
//       } catch (error) {
//         console.error('Error fetching data:', error);
//         setError(error.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchDemat();
//   }, [id]);

//   const toggleAccordion = (index) => {
//     if (activeIndex === index) {
//         setActiveIndex(null);
//     } else {
//         setActiveIndex(index);
//     }
// };
//   if (loading) {
//     return<div class="spinnerContainer">
//     <div class="spinner"></div>
//     <div class="loader">
//       <p>loading</p>
//       <div class="words">
//         <span class="word">images</span>
//         <span class="word">Title</span>
//         <span class="word">Card</span>
//         <span class="word">Bank Card</span>
//       </div>
//     </div>
//   </div>
//   }

//   if (error) {
//     return <p>Error: {error}</p>;
//   }

//   if (!demat) {
//     return <p>No Card found.</p>;
//   }
// // const {content_category, content_date, 
// //     content_description, 
// //     content_image, 
// // content_keyword, content_meta,
// // content_meta_description,
// // content_title} = blogs[0];

//   return (
//     <>
//     <Helmet>
//         <title>{demat.metatitle}</title>
//         <meta name='description' content={demat.metadesc} />
//         <meta name='keywords' content={demat.metakeyword} />
//       </Helmet>
//       <FAQSchema faqs={demat.demat_faq} />
//       <nav className="text-gray-500 text-sm my-4 ml-12" aria-label="Breadcrumb">
//         <ol className="list-none p-0 inline-flex">
//           <li className="flex items-center">
//             <Link to="/" className="text-blue-600 hover:text-blue-800 ">Home</Link>
//             <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
//               <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
//             </svg>
//           </li>
//           <li className="flex items-center">
//             <Link to="/demat_page" className="text-blue-600 hover:text-blue-800">Loan Page</Link>
//             <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
//               <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
//             </svg>
//           </li>

//         </ol>
//       </nav>
//       <div className="container mx-auto px-4 py-8">
//   <div className="flex flex-col lg:flex-row gap-12">
//     <div className="lg:w-3/4">
//       <div className="w-full mx-auto">
//         <img
//           src={demat.image}
//           alt={demat.page_title}
//           className="w-full h-auto rounded"
//         />
//       </div>
//       <h2 className="text-3xl mt-8 font-bold mb-4 text-blue-500 cursor-pointer">
//         {demat.page_title}
//       </h2>
//       <p className="text-2xl mt-4 font-semibold mb-4 text-gray-700">
//         {demat.page_description}
//       </p>
      
//     </div>

//     {/* Uncomment and customize the sidebar as needed */}
//     {/* <div className='lg:w-1/4'>
//       <SideBar />
//     </div> */}
//   </div>
// </div>
// <div className="text-gray-700 text-base mb-6 px-12 ">
//         <p dangerouslySetInnerHTML={{ __html: demat.page_details }}></p>
//       </div>
//       <div className="max-w-4xl mx-auto py-6">
//                         <h1 className="text-3xl font-semibold text-center mb-8">Frequently Asked Questions</h1>
//                         <div className="space-y-4">
//                             {demat.demat_faq.map((faq, index) => (
//                                 <div key={index} className="border rounded-lg overflow-hidden shadow-md">
//                                     <button
//                                         onClick={() => toggleAccordion(index)}
//                                         className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
//                                     >
//                                         {faq.question}
//                                         <svg
//                                             className={`w-6 h-6 transition-transform transform ${
//                                                 activeIndex === index ? 'rotate-180' : ''
//                                             }`}
//                                             fill="none"
//                                             viewBox="0 0 24 24"
//                                             stroke="currentColor"
//                                         >
//                                             <path
//                                                 strokeLinecap="round"
//                                                 strokeLinejoin="round"
//                                                 strokeWidth="2"
//                                                 d={activeIndex === index ? 'M19 9l-7 7-7-7' : 'M9 5l7 7 7-7'}
//                                             />
//                                         </svg>
//                                     </button>
//                                     {activeIndex === index && (
//                                         <div className="p-4 bg-gray-100">
//                                             <p className="text-gray-600">{faq.answer}</p>
//                                         </div>
//                                     )}
//                                 </div>
//                             ))}
//                         </div>
//                     </div>
//     </>
  
//   );
// };

// export default SingleDematPage;
